<template>
    <Breadcrumbs main="Buttons" title="Edge Buttons" />
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
                <edgesButtons />
                <edgesButtons2 />
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const edgesButtons = defineAsyncComponent(() => import("@/components/theme/buttons/edge/edgesButtons.vue"))
const edgesButtons2 = defineAsyncComponent(() => import("@/components/theme/buttons/edge/edgesButtons2.vue"))

</script>